import { render, staticRenderFns } from "./LmsPayments.vue?vue&type=template&id=0b23c902&scoped=true"
import script from "./LmsPayments.vue?vue&type=script&lang=js"
export * from "./LmsPayments.vue?vue&type=script&lang=js"
import style1 from "./LmsPayments.vue?vue&type=style&index=1&id=0b23c902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23c902",
  null
  
)

export default component.exports